import { SYSTEM_ENUM } from '@/constant';

// 跳转SSO登陆页面
export const jumpSSOLogin = (ssoLoginUrl: string) => {
  window.location.href = `${
    ssoLoginUrl
  }/saas-sso/auth/toLogin?server=${encodeURIComponent(window.location.href)}&systemCode=${SYSTEM_ENUM.OPS}`;
};

// 跳转SSO退出登陆页面
export const jumpSSOLogout = (ssoLoginUrl: string) => {
  window.location.href = `${
    ssoLoginUrl
  }/saas-sso/auth/logout?server=${encodeURIComponent(`${window.location.origin}/#/`)}&systemCode=${SYSTEM_ENUM.OPS}`;
};
